import { render, staticRenderFns } from "./extracao.vue?vue&type=template&id=eb939fbc&scoped=true&"
import script from "./extracao.vue?vue&type=script&lang=js&"
export * from "./extracao.vue?vue&type=script&lang=js&"
import style0 from "./extracao.vue?vue&type=style&index=0&id=eb939fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb939fbc",
  null
  
)

export default component.exports